import { computed } from 'vue'
import { getCVSectionTranslations } from '~/constants/cvSectionTranslations'

/**
 * Composable for accessing CV section translations based on CV language
 * @param cvLanguage - The language code from CVData (e.g., 'en', 'cs', 'de')
 * @returns Object with translated section names
 */
export function useCVSectionTranslations(cvLanguage: Ref<string | undefined> | string | undefined) {
  const language = computed(() => {
    if (typeof cvLanguage === 'string') {
      return cvLanguage
    }
    return unref(cvLanguage) || 'cs'
  })

  const translations = computed(() => {
    return getCVSectionTranslations(language.value)
  })

  return {
    translations,
    t: (key: keyof typeof translations.value) => translations.value[key],
  }
}

